import { lazy, useRef } from 'react';

const FORCE_EDIT_MODE = false;

type Props = JSX.IntrinsicElements['mesh'] & {
    editMode?: boolean;
};

const Editor = lazy(() => import('scripts/animations/editing/editors'));

export const HoverWrapper = (propsAll: Props) => {
    const { editMode: _editMode, ...props } = propsAll;

    const rootRef = useRef<THREE.Mesh>();
    const editMode = import.meta.env.PUBLIC_APP_ENV !== 'production' && (FORCE_EDIT_MODE || _editMode);

    return (
        <mesh
            {...props}
            ref={rootRef}
        >
            {editMode && <Editor targetRef={rootRef} schemaKey='hover_editor' /> }
            <boxGeometry
                args={[100, 100, 100]}
            />
            <meshBasicMaterial
                transparent
                opacity={editMode ? 0.1 : 0}
                color={0xFF0000}
                wireframe={editMode}
            />
        </mesh>
    );
};
